import { Button } from '@neo/index'
import { cn } from '@neo/lib/utils'

interface ToggleGroupProps {
  value: string | undefined
  onChange: (value: string) => void
  options: { name: string; label: string }[]
  className?: string
}

export const ToggleGroup = ({ options, value, onChange, className }: ToggleGroupProps) => {
  if (!value) onChange(options[0].name)
  return (
    <div className={cn('relative flex items-center rounded-md fit-content', className)}>
      <div className="inline-flex rounded-lg bg-hv2 p-1 shadow-none">
        {options.map((option: { name: string; label: string }) => (
          <Button
            key={option.name}
            type="button"
            onClick={() => onChange(option.name)}
            size="sm"
            className={cn(
              'py-1 px-3 rounded-md transition-colors border-none shadow-none',
              option.name === value
                ? 'bg-background text-primary shadow-sm hover:bg-background'
                : 'px-2 text-secondary bg-bg1 hover:text-primary hover:bg-bg1',
            )}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </div>
  )
}
